(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.faq-tab');
    const lists = document.querySelectorAll('.faq-list');

    // --- Helper: apply default open count ---
    const applyDefaultOpen = (list) => {
      const details = list.querySelectorAll('details');
      const isDesktop = window.innerWidth >= 1024;
      const count = isDesktop ? 3 : 1;
      details.forEach((d, i) => {
        if (i < count) d.setAttribute('open', '');
        else d.removeAttribute('open');
      });
    };

    // --- Tab switching ---
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');

        lists.forEach((list) => {
          const isActive = list.dataset.content === tab.dataset.tab;
          list.classList.toggle('active', isActive);
          if (isActive) {
            list.querySelectorAll('details').forEach((d) => d.removeAttribute('open'));
            applyDefaultOpen(list);
          }
        });
      });
    });

    // --- Initial load ---
    const activeList = document.querySelector('.faq-list.active');
    if (activeList) applyDefaultOpen(activeList);

    // --- Resize handler (debounced + ignore mobile scroll resize) ---
    let resizeTimeout;
    let lastWidth = window.innerWidth;

    window.addEventListener('resize', () => {
      const currentWidth = window.innerWidth;

      if (currentWidth === lastWidth) return;

      lastWidth = currentWidth;
      clearTimeout(resizeTimeout);

      resizeTimeout = setTimeout(() => {
        const activeList = document.querySelector('.faq-list.active');
        if (activeList) applyDefaultOpen(activeList);
      }, 60);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
